module.exports = __webpack_public_path__ + "static/media/mic.f36d7d60.svg";